import { useCallback } from 'react';
import { useQueryClient, useQuery } from '../lib';
import { useTribeClient } from '../useTribeClient';
import { getSearchKey } from '../utils/keys';
export const useSearch = (options) => {
    var _a;
    const { variables, fields, useQueryOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    const asyncSearch = useCallback(async (variables) => {
        const data = await queryClient.fetchQuery(getSearchKey(variables), () => client.search(variables, fields), useQueryOptions);
        return data;
    }, [queryClient, client, useQueryOptions, fields]);
    return {
        ...useQuery(getSearchKey(variables), () => client.search(variables, fields), { ...useQueryOptions, enabled: !!((_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.query) }),
        asyncQuery: asyncSearch,
    };
};
//# sourceMappingURL=useSearch.js.map